import type { DashboardWidgetSize } from "@repo/shared/types";
import { cn } from "@/lib/utils";

/** Filled blocks out of the row's columns: four for key figures, three for sections. */
const BLOCKS: Record<DashboardWidgetSize, { filled: number; of: number }> = {
  "1/4": { filled: 1, of: 4 },
  "1/3": { filled: 1, of: 3 },
  "2/3": { filled: 2, of: 3 },
  full: { filled: 3, of: 3 },
};

/** A widget's fixed size as a tiny row of blocks, with its label. */
export function SizeGlyph({ size, label }: { size: DashboardWidgetSize; label: string }) {
  const { filled, of } = BLOCKS[size];
  return (
    <div className="flex items-center gap-2">
      <div className="flex gap-0.5">
        {Array.from({ length: of }, (_, i) => (
          <div
            // biome-ignore lint/suspicious/noArrayIndexKey: fixed, never reordered
            key={i}
            className={cn(
              "h-2 rounded-sm",
              of === 4 ? "w-4" : "w-5.5",
              i < filled ? "bg-foreground" : "bg-muted-foreground/30",
            )}
          />
        ))}
      </div>
      <span className="w-7 text-xs font-medium text-muted-foreground">{label}</span>
    </div>
  );
}
